import type {
  CreateRoleRequest,
  Role,
} from "@/core/administration/entities/Roles";
import type { Permission } from "@/core/administration/entities/Rule";

export interface ApiCreateRolePermission {
  name: string;
  domaine: string;
  action: string;
  ressource: string;
}

export interface ApiCreateRoleBody {
  name: string;
  description: string;
  owner: string;
  porte: string;
  criticite: string;
  permissions: ApiCreateRolePermission[];
}

export interface ApiCreatedRoleData {
  id: string;
  name: string;
  status: string;
  sodResult?: {
    maxLevel: string;
    conflicts: {
      ruleId: string;
      level: string;
      description: string;
    }[];
  };
}

export default class CreateRoleMapper {
  private static mapScopeToPorte(scope: string): string {
    const normalized = (scope || "").toLowerCase();

    switch (normalized) {
      // Backend enum values: [FILALE, ENVIRONNEMENT, PAYS]
      case "filiale":
        return "FILALE";
      case "pays":
        return "PAYS";
      case "environnement":
        return "ENVIRONNEMENT";
      default:
        return scope.toUpperCase();
    }
  }

  static toApiRequest(input: CreateRoleRequest): ApiCreateRoleBody {
    const directPermissions: Permission[] = input.directPermissions ?? [];

    const apiPermissions: ApiCreateRolePermission[] = directPermissions.map(
      (p) => ({
        name: p.label ?? `${p.domain}:${p.action}:${p.resource}`,
        domaine: p.domain,
        action: p.action,
        ressource: p.resource,
      }),
    );

    return {
      name: input.name,
      description: input.purpose,
      owner: input.ownerId,
      porte: CreateRoleMapper.mapScopeToPorte(input.scope),
      criticite: input.criticality.toUpperCase(),
      permissions: apiPermissions,
    };
  }

  static toDomainRole(
    api: ApiCreatedRoleData,
    original: CreateRoleRequest,
  ): Role {
    return {
      id: api.id,
      name: api.name || original.name,
      assignations: 0,
      // Backend criticity is not explicitly returned in the payload;
      // we keep the one from the request for now.
      criticite: original.criticality,
      statut: api.status || "DRAFT",
    };
  }
}
